var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#A0A3BD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.166 12.593c0 1.147-1.066 2.074-2.38 2.074-1.313 0-2.386-.927-2.386-2.074V11.24c0 1.147 1.066 1.96 2.386 1.96 1.314 0 2.38-.82 2.38-1.96v1.353z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.913 10.313c-.393.647-1.2 1.053-2.133 1.053s-1.74-.413-2.133-1.053a1.749 1.749 0 01-.254-.907c0-.573.267-1.086.694-1.46.433-.38 1.026-.606 1.686-.606.66 0 1.254.233 1.687.606.44.367.707.887.707 1.46 0 .334-.094.64-.254.907z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.166 11.24c0 1.147-1.066 1.96-2.38 1.96-1.313 0-2.386-.82-2.386-1.96V9.407c0-1.147 1.066-2.074 2.386-2.074.66 0 1.254.234 1.687.607.427.373.693.893.693 1.467v1.833z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8.687a.684.684 0 01-.667.68h-1.307c-.72 0-1.38-.527-1.44-1.247-.04-.42.12-.813.4-1.087.247-.253.587-.4.96-.4H14a.684.684 0 01.667.68v1.374z",
    stroke: "#403D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.333 7V5.667c0-1.814 1.094-3.08 2.794-3.294.173-.026.353-.04.54-.04h6c.173 0 .34.007.5.034 1.72.2 2.833 1.473 2.833 3.3v.966h-1.387c-.373 0-.713.147-.96.4-.28.274-.44.667-.4 1.087.06.72.72 1.247 1.44 1.247H14v.966c0 2-1.333 3.334-3.333 3.334H9",
    stroke: "#403D5A"
  }))));
}

export default SvgWalletMoney;